import { Component, Injectable, OnInit } from "@angular/core";
import { ComponentBase } from "./dynamic/component-base";
import { AttributeModel } from "./dynamic/model/attribute.model";

@Component({
    template: ''
})
export abstract class FilterComponentBase extends ComponentBase implements OnInit {
        
    constructor() { 
        super() 
    }

    ngOnInit() {
    }

    doSearch() {
        this.emit({ name: "doSearch" })
    }

    getPlaceholder(): string {
        let placeHolderOpt = this.attribute.options.find(opt => opt.key.toLowerCase() == "placeholder")

        if(placeHolderOpt) {
            return placeHolderOpt.value
        }
        
        return ""
    }

    getBinding(): AttributeModel[] {
        let binding = this.attribute.attributes
            .find(attr => attr.type.toLowerCase() == "binding")

        if(binding && binding.attributes) {
            return binding.attributes
        }

        return []
    }
}